module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-29.705ab2e2.svg";